import type { FC, ReactElement } from "react";

import { type ITooltipProps, Tooltip } from "@similarweb/ui-components";

import withDelayedHoverEvent from "app/pages/sales-intelligence/hoc/withDelayedHoverEvent";
import withMouseEventHandlers from "app/pages/sales-intelligence/hoc/withMouseEventHandlers";

import { columnsSelectionTrackingService } from "../columnsSelectionTrackingService";
import ColumnsSelectionButton from "../components/ColumnsSelectionButton/ColumnsSelectionButton";

type ColumnsSelectionButtonProps = {
    tooltipContent?: ITooltipProps["content"];
    isDisabled?: boolean;
    withTooltip?: boolean;
    suggestionsCount?: number;
    onClick: VoidFunction;
};

const ButtonWithHoverEvents = withDelayedHoverEvent(withMouseEventHandlers(ColumnsSelectionButton));

const ColumnsSelectionButtonContainer: FC<ColumnsSelectionButtonProps> = ({
    isDisabled = false,
    withTooltip = true,
    tooltipContent,
    suggestionsCount = 0,
    onClick,
}): ReactElement => {
    const handleClickTracked = () => {
        onClick();
        columnsSelectionTrackingService.columnPickerButton.trackClicked(suggestionsCount);
    };

    const handleOnMouseEnter = () => {
        columnsSelectionTrackingService.columnPickerButton.trackHovered(suggestionsCount);
    };

    return (
        <Tooltip
            placement="top"
            enabled={!isDisabled ? withTooltip : false}
            content={tooltipContent}
        >
            <div>
                <ButtonWithHoverEvents
                    isDisabled={isDisabled}
                    onClick={handleClickTracked}
                    onMouseEnter={handleOnMouseEnter}
                />
            </div>
        </Tooltip>
    );
};

export default ColumnsSelectionButtonContainer;
